import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { XcibilReportComponent } from './xcibil-report.component';




@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    
],
  declarations: [XcibilReportComponent]
})
export class ViewReportModule {}
